export default {
  defaultBudgetId: {
    type: 'string',
  },
  skillName: {
    type: 'string',
    required: true,
  },
};
